// @ts-check
import { ssn } from '@/Validators/ssn.js';
import { email, maxLength, required } from '@vuelidate/validators';
import GroupMembershipModel from '@/Models/GroupMembershipModel';

export class UserModel {
  constructor({
    Id = null,
    Personnummer,
    LanguageId,
    PatientId,
    Username,
    Email = null,
    EmailConfirmed = false,
    FirstName = '',
    LastName = '',
    OptOut,
    OptOutDate = null,
    PhoneNumber,
    Research,
    Roles = [],
    ReportCount = 0,
    LastActivity,
    Permissions = [],
    GroupMemberships = []
  }) {
    this._modelName = 'User';
    this.Id = Id;
    this.Personnummer = Personnummer;
    this.LanguageId = LanguageId;
    this.PatientId = PatientId;
    this.Username = Username;
    this.Email = Email;
    this.EmailConfirmed = EmailConfirmed;
    this.FirstName = FirstName;
    this.LastName = LastName;
    this.OptOut = OptOut;
    this.OptOutDate = OptOutDate;
    this.PhoneNumber = PhoneNumber;
    this.Research = Research;
    this.Roles = Roles;
    this.ReportCount = ReportCount;
    this.LastActivity = LastActivity;
    /** @type {String[]} */
    this.Permissions = Permissions;
    this.GroupMemberships = GroupMemberships.map(
      gm => new GroupMembershipModel(gm)
    );
  }

  get FullName() {
    if (!this.FirstName && !this.LastName) {
      return '';
    }
    return `${this.FirstName} ${this.LastName}`;
  }

  static get validations() {
    return {
      FirstName: {
        maxLength: maxLength(32)
      },
      LastName: {
        maxLength: maxLength(32)
      },
      Email: {
        email
      },
      Personnummer: { required, ssn },
      Password: {},
      Roles: {}
    };
  }

  __copy() {
    return JSON.parse(JSON.stringify(this));
  }
}

export default UserModel;
